import configs from "../../configs.js";

const configuredPopupTimeout = Number(configs.AUTH0_POPUP_TIMEOUT_SECONDS);
export const AUTH_POPUP_TIMEOUT_SECONDS =
  Number.isFinite(configuredPopupTimeout) && configuredPopupTimeout > 0 ? configuredPopupTimeout : 300;

export function normalizePopupAuthError(error) {
  if (!error) {
    return { code: "auth_popup_unknown", popup: null, original: error };
  }

  if (typeof error?.code === "string" && error.code.startsWith("auth_popup_")) {
    return {
      code: error.code,
      popup: error.popup || null,
      original: error.original || error
    };
  }

  const message = String(error?.message || "").toLowerCase();
  const errorCode = String(error?.error || "").toLowerCase();
  const name = String(error?.name || "").toLowerCase();

  if (errorCode === "timeout" || name === "popuptimeouterror" || message.includes("timeout")) {
    return { code: "auth_popup_timeout", popup: error?.popup || null, original: error };
  }

  if (
    errorCode === "popup_blocked" ||
    name === "popupblockederror" ||
    message.includes("popup blocked") ||
    message.includes("unable to open a popup")
  ) {
    return { code: "auth_popup_blocked", popup: error?.popup || null, original: error };
  }

  if (
    errorCode === "cancelled" ||
    name === "popupcancellederror" ||
    message.includes("popup closed") ||
    message.includes("closed")
  ) {
    return { code: "auth_popup_closed", popup: error?.popup || null, original: error };
  }

  return { code: "auth_popup_unknown", popup: error?.popup || null, original: error };
}

export function shouldShowPopupRetryDialog(code) {
  return code === "auth_popup_timeout" || code === "auth_popup_blocked";
}

export function buildPopupConfig(config = {}) {
  return {
    timeoutInSeconds: AUTH_POPUP_TIMEOUT_SECONDS,
    ...config
  };
}

export function safelyClosePopupFromError(normalizedError) {
  try {
    const popup = normalizedError?.popup;
    if (popup && typeof popup.close === "function") {
      popup.close();
    }
  } catch (_) {
    // Best-effort close only.
  }
}

export function createAuthPopupFailure({ code = "auth_popup_unknown", popup = null, original = null } = {}) {
  const error = new Error(code);
  error.code = code;
  error.popup = popup;
  error.original = original;
  return error;
}
